import { Text, View } from '@react-pdf/renderer'
import {
  PerformanceAgreementPrintableAgreementTrainingsFragment,
  PerformanceProcessPrintableAgreementFragment,
  PerformanceProcessPrintableAgreementTrainingRequestsFragment,
} from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { Section, SectionTitle } from './_Blocks'

const MAX_COMPETENCIES = 3
export const Trainings: React.FC<{
  agreement: PerformanceProcessPrintableAgreementFragment
  trainingRequests: PerformanceProcessPrintableAgreementTrainingRequestsFragment
  trainings: Array<PerformanceAgreementPrintableAgreementTrainingsFragment>
}> = ({ agreement, trainingRequests, trainings }) => {
  const agreementYear = new Date(String(agreement.targetSignedAt)).getFullYear()

  return (
    <>
      {trainings.length && (
        <Section>
          <SectionTitle>
            {i18n.t('performance_process.agreements.printable_pdf.trainings.completed.title', {
              year: agreementYear,
            })}
          </SectionTitle>
          <View wrap={false} style={{ display: 'flex', flexDirection: 'column', gap: '15' }}>
            {trainings
              .filter(
                (training) =>
                  training.trainingAttendanceStatus === 'completed' &&
                  training.year === agreementYear
              )
              .map((training, index) => (
                <View key={training.id} style={{ flexDirection: 'column', gap: '5' }}>
                  <View style={{ flexDirection: 'row', gap: '10' }}>
                    <Text>
                      <Text style={{ fontWeight: 'bold', width: '20' }}>{index + 1}. </Text>
                      {training.name}
                    </Text>
                    {/* <Text>
                    {i18n.t(
                      'performance_process.agreements.printable_pdf.trainings.completed.completed_on'
                    )}
                    : {training.trainingAttendanceStatus}
                  </Text> */}
                  </View>
                  <Text>
                    {i18n.t('performance_process.agreements.printable_pdf.trainings.competencies')}:{' '}
                    {training.competencies.nodes
                      .map(({ name }: { name: string }) => name)
                      .join(', ')}
                    {training.competencies.totalCount &&
                    training.competencies.totalCount > MAX_COMPETENCIES
                      ? ', ...'
                      : ''}
                  </Text>
                </View>
              ))}
          </View>
        </Section>
      )}

      {trainingRequests?.agreementTrainingRequests?.length && (
        <Section>
          <SectionTitle>
            {i18n.t('performance_process.agreements.printable_pdf.trainings.requested.title')}
          </SectionTitle>
          <View wrap={false} style={{ display: 'flex', flexDirection: 'column', gap: '15' }}>
            {trainingRequests.agreementTrainingRequests.map(({ trainingRequest }, index) => (
              <View key={trainingRequest.id} style={{ flexDirection: 'column', gap: '5' }}>
                <Text>
                  <Text style={{ fontWeight: 'bold', width: '20' }}>{index + 1}. </Text>
                  {trainingRequest.training?.name}
                </Text>
                <View style={{ flexDirection: 'row', gap: '10' }}>
                  <Text>
                    {i18n.t(
                      'performance_process.agreements.printable_pdf.trainings.requested.author'
                    )}
                    : {trainingRequest.author?.fullName || '-'}
                  </Text>
                  <Text>
                    {i18n.t(
                      'performance_process.agreements.printable_pdf.trainings.requested.status'
                    )}
                    : {trainingRequest.status}
                  </Text>
                </View>
              </View>
            ))}
          </View>
        </Section>
      )}
    </>
  )
}
